import {Utilisateur} from '../api/Utilisateur';
import {Adresse} from '../api/Adresse';
import {UtilisateurRoleInterface} from '../api/UtilisateurRole';
import {ROLE_KEYS} from '../../core/consts/roles';
import {MandatInterface} from '../api/Mandat';
import {UtilisateurSignatureInterface} from '../api/UtilisateurSignature';

export class ExUtilisateur extends Utilisateur {
    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }

        if (this.phdDate != null) {
            this.phdDate = this.phdDate.toString().substring(0, 10) as any;
        }

        if (this.dateNaissance != null) {
            this.dateNaissance = this.dateNaissance.toString().substring(0, 10) as any;
        }

        if (this.adresse && typeof this.adresse != 'string') {
            this.adresse = new Adresse(this.adresse);
        }
    }


    public isRole(key: string): boolean {
        return this.utilisateurRoles.find(item => item.code === key) !== undefined;
    }

    public isExpert(): boolean {
        return this.isRole(ROLE_KEYS.expert);
    }

    public isPresident(): boolean {
        return this.isRole(ROLE_KEYS.president);
    }

    public isAdmin(): boolean {
        return this.isRole(ROLE_KEYS.superadmin);
    }

    public isSuperAdmin(): boolean {
        return this.isRole(ROLE_KEYS.superadmin);
    }

    public isPartner(): boolean {
        return this.isRole(ROLE_KEYS.partner);
    }

    public isAssociate(): boolean {
        return this.isRole(ROLE_KEYS.associate);
    }

    public getRoleString(): string {
        let roles = [];

        this.utilisateurRoles.forEach(
            (item: UtilisateurRoleInterface) => {
                if (item.code === 'ROLE_EXPERT') {
                    roles.push('Expert');
                }

                if (item.code === 'ROLE_PRESIDENT') {
                    roles.push('President | Vice President');
                }

                if (item.code === 'ROLE_ADMIN') {
                    roles.push('Admin');
                }
            });

        if (roles.length === 0) {
            roles = ['Candidat'];
        }

        return roles.join(' / ');
    }

    public getDernierMandatPasse(): MandatInterface | null {
        const now: Date = new Date();

        return (this.mandats as MandatInterface[]).reduce(
            (retour: MandatInterface | null, mandat: MandatInterface) => {
                const dateFin = new Date(mandat.dateFin ?? '2099');

                if (dateFin < now && (!retour || dateFin > new Date(retour.dateFin ?? '2099'))) {
                    return mandat;
                }

                return retour;
            },
            null
        );
    }

    public hasMandatEnCours(): boolean {
        const now: Date = new Date();
        const thisMorning = new Date();
        thisMorning.setHours(0, 0, 0, 0);

        return undefined !== (this.mandats as MandatInterface[]).find(
            (mandat: MandatInterface) => (
                    new Date(mandat.dateFin ?? '1970') >= thisMorning
                    && new Date(mandat.dateDebut ?? '2099') <= now
                )
        );
    }


    public getLastSignatureOfSet(items: UtilisateurSignatureInterface[]): UtilisateurSignatureInterface | undefined {
        return items.reduce(
            (
                previous: UtilisateurSignatureInterface | null,
                item: UtilisateurSignatureInterface
            ) => !previous ? item : new Date(previous.dateFin) > new Date(item.dateFin) ? previous : item,
            undefined
        );
    }

    public hasValidSignatureForCode(code: string): boolean {
        return undefined !== this.getValidSignatureForCode(code);
    }

    public getValidSignatureForCode(code: string): UtilisateurSignatureInterface | undefined {
        const now = new Date();

        return this.getLastSignatureOfSet(
            this.getSignaturesForCode(code).filter(item => new Date(item.dateFin) > now)
        );
    }

    public getLastSignatureForCode(code: string): UtilisateurSignatureInterface | undefined {
        return this.getLastSignatureOfSet(this.getSignaturesForCode(code));
    }

    public getSignaturesForCode(code: string): UtilisateurSignatureInterface[] | undefined {
        return (this.utilisateurSignatures as UtilisateurSignatureInterface[]).filter(item => item.code === code);
    }
}
